import React from "react";

import HelpIcon from "@uui/HelpCircle";

import { Button, ButtonProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack, { Column, StackProps } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

export const ModalContent = styled(Column)(({ theme }) => ({
  borderTop: "1px solid",
  borderBottom: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  padding: theme.spacing(0, 3),
  overflowY: "auto",
  flexShrink: 1,
  color: theme.palette.shades.neutral[700],
}));

type SettingContainerProps = StackProps & { disableWrap?: boolean };

export const SettingContainer = styled<React.FC<SettingContainerProps>>(
  ({ disableWrap: _dw, ...props }) => <Stack {...props} />
)(({ disableWrap = false, theme }) => ({
  flexDirection: disableWrap ? "row" : "column",
  flexWrap: disableWrap ? undefined : "wrap",
  justifyContent: disableWrap ? "space-between" : "center",
  alignItems: disableWrap ? "center" : undefined,
  borderBottom: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  padding: theme.spacing(2, 0),
  width: "100%",
  maxWidth: "100%",
  rowGap: theme.spacing(1),
  columnGap: theme.spacing(2),
  "&.no-border": {
    paddingBottom: theme.spacing(0),
    borderBottom: "none",
  },
  "&:last-of-type": {
    borderBottom: "none",
  },
  [theme.breakpoints.up("sm")]: {
    rowGap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

export const WhatsThis = styled<React.FC<ButtonProps>>(
  ({ title, ...props }) => (
    <TooltipWrapper title={title} placement="bottom-start">
      <Button {...props} startIcon={<HelpIcon />}>
        What's this?
      </Button>
    </TooltipWrapper>
  )
)(({ theme }) => ({
  padding: "2px 4px 2px 8px",
  color: theme.palette.shades.neutral[400],
  fontSize: "0.75rem",
  "& .MuiButton-startIcon": {
    marginRight: "4px",
    svg: {
      transition: "color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      color: theme.palette.shades.neutral[300],
      fontSize: "14px",
    },
  },
  "&:hover": {
    color: theme.palette.shades.secondary[500],
    "& .MuiButton-startIcon svg": {
      color: theme.palette.shades.secondary[500],
    },
  },
}));
